import { createFileRoute } from "@tanstack/react-router"

import { SettingsPlaceholder } from "@/features/settings/components/settings-placeholder"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/offboarding/"
)({
  component: OffboardingSettingsPage,
})

function OffboardingSettingsPage() {
  return <SettingsPlaceholder title="Offboarding" />
}
